import React, {useState} from 'react';
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import {Avatar, FormHelperText, ListItemAvatar, Skeleton} from "@mui/material";
import {apiDateTimeStringToDate} from "src/api/apiDateTimeHandler";
import CancelAppointmentButton from "src/components/project/CancelAppointmentButton";
import {appointmentType} from "src/types/appointmentType";

const AppointmentListItem = ({appointment, onCancelSuccess}) => {
  const [cancelError, setCancelError] = useState();

  function getParsedStartString(appointment) {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    }
    return apiDateTimeStringToDate(appointment.projectInstance.start)
      .toLocaleString('nl-NL', options);
  }

  return (
    <>
      <ListItem
        key={appointment.id}
        secondaryAction={
          <CancelAppointmentButton
            appointment={appointment}
            setCancelError={setCancelError}
            onSuccess={onCancelSuccess}
            buttonVariant="outlined"
          />
        }
      >
        <ListItemAvatar>
          {
            (appointment.projectInstance.project.image && appointment.projectInstance.project.image.contentUrl)
              ? <Avatar src={appointment.projectInstance.project.image.contentUrl} />
              : <Skeleton variant="circular"><Avatar /></Skeleton>
          }
        </ListItemAvatar>
          <ListItemText
            primary={appointment.projectInstance.project.name}
            secondary={getParsedStartString(appointment)}
            sx={{maxWidth: '200px'}}
          />
      </ListItem>
      { cancelError && <FormHelperText error>{cancelError}</FormHelperText>}
    </>
  );
}

export default AppointmentListItem;

AppointmentListItem.propTypes = {
  appointment: appointmentType.isRequired
};
